<div class="search-container">
  <mat-form-field appearance="outline">
    <mat-select
      [formControl]="itemsMultiCtrl"
      [placeholder]="placeholder"
      [multiple]="true"
      #multiSelect
      (selectionChange)="setFilter()"
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="itemsMultiFilterCtrl"
          placeholderLabel="Search..."
          noEntriesFoundLabel="No matching found"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let item of filteredItemsMulti | async"
        [value]="item"
      >
        <span *ngIf="!uppercase">{{ item.text || item.name | cityName }}</span>
        <span *ngIf="uppercase">{{
          item.text || item.name | isEmpty | uppercase
        }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
